'use client';
import * as React from 'react';
import { useCalendlyModal } from '../hooks/use-calendly-modal';
import { CalendlyProps } from '../lib/types';
import { ComponentProps } from 'react';

interface Props <T extends React.FC> {
  onClick?: (e: any) => void;
  calendlyProps?: CalendlyProps & { width?: number | string, subtitle?: string };
  onClose?: () => void;
  Component: T;
  componentProps?: ComponentProps<T>;
}

export const ScheduleACallClickable = (props: Props<any>) => {
  const openCalendly = useCalendlyModal();
  const { calendlyProps, onClose, onClick, Component, componentProps } = props;

  const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    onClick && onClick(e);
    openCalendly(calendlyProps).finally(onClose)
  };

  return (
    <Component {...componentProps} onClick={handleClick} />
  )
};
